// Tells you if a form's fields have been changed since it was first loaded (or when we last took a "snapshot" of the values).
// Either add the formDirtyChecker class to your form or use this manually via the API.
// You can also add a form_dirty_checker_ignore HTML data value to tell this to ignore fields in the dirty checking. Format is CSV: field1,field2,field3.

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.formDirtyChecker = abcsetup.formDirtyChecker || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    abcsetup.formDirtyChecker.init();
});


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.formDirtyChecker = {
    init() {
        this.clearSnapshots();
        $('form.formDirtyChecker').each((index, form) => this.takeSnapshot(form));
    },

    /**
     * Clear out all snapshots from storage.
     */
    clearSnapshots() {
        sessionStorage.setItem('formDirtyChecker-Snapshots', '');
    },

    /**
     * Take a snapshot of the form's current values.
     *
     * @param {HTMLFormElement} form
     */
    takeSnapshot(form) {
        const existingSnapshots = this._getSnapshots();
        const snapshotID = this._hasSnapshot(form)
            ? $(form).data('formDirtyCheckerSnapshotID')
            : existingSnapshots.length;

        existingSnapshots[snapshotID] = this._makeSnapshot(form);
        $(form).data('formDirtyCheckerSnapshotID', snapshotID);

        this._updateSnapshots(existingSnapshots);
    },


    /**
     * Is the given form "dirty"? Have its values changed?
     *
     * @param {HTMLFormElement} form
     * @returns {boolean}
     */
    isDirty(form) {
        if (!this._hasSnapshot(form)) {
            throw new Error('Cannot check if form is dirty. You must take a snapshot first.');
        }

        return this._makeSnapshot(form) !== this._retrieveSnapshot(form);
    },

    /**
     * Make a snapshot for the given form.
     *
     * @param form
     * @returns {string}
     * @private
     */
    _makeSnapshot(form) {
        const fieldsToIgnore = String($(form).data('form_dirty_checker_ignore') || '')
            .split(',')
            .filter(Boolean)
            .concat('_method', '_token'); // Auto-ignore Laravel's special hidden fields.

        return $(form).serializeArray()
            .filter(field => !fieldsToIgnore.includes(field.name))
            .map(field => field.name + field.value)
            .sort()
            .join('');
    },

    /**
     * Does the given form have a snapshot?
     *
     * @param form
     * @returns {boolean}
     * @private
     */
    _hasSnapshot(form) {
        return Number.isInteger($(form).data('formDirtyCheckerSnapshotID'));
    },

    /**
     * Gives you the stored snapshot for the given form.
     *
     * @param form
     * @returns {string|null|undefined}
     * @private
     */
    _retrieveSnapshot(form) {
        return this._hasSnapshot(form)
            ? this._getSnapshots()[$(form).data('formDirtyCheckerSnapshotID')]
            : null;
    },

    /**
     * All of the saved snapshots for forms on the page.
     *
     * @returns {[]}
     * @private
     */
    _getSnapshots() {
        const rawSnapshots = sessionStorage.getItem('formDirtyChecker-Snapshots');
        let result = null;

        if (rawSnapshots.startsWith('[')) {
            result = JSON.parse(rawSnapshots);
        }

        return Array.isArray(result) ? result : [];
    },

    /**
     * Update the snapshots we have saved.
     *
     * @param snapshots
     * @private
     */
    _updateSnapshots(snapshots) {
        sessionStorage.setItem(
            'formDirtyChecker-Snapshots',
            JSON.stringify(Array.isArray(snapshots) ? snapshots : [])
        );
    }
}
